"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.weekDaysHeaderStyles);
const WeekDaysHeader = ({ days }) => {
    const { classes } = useStyles();
    return (<header className={classes.weekDays}>
      {days.map((weekday) => (<strong key={weekday} className={classes.dayLabel}>{weekday}</strong>))}
    </header>);
};
exports.default = WeekDaysHeader;
